// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.companySavingTitle__ziGB_ {
  color: var(--title-inputs-sections-title);
  font-style: normal;
  line-height: 14px;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 11px;
  margin: unset;
  margin-bottom: 10px;
}

.companySavingBlockContainer__xfzmi {
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--basic-box-shadow);
  display: flex;
  align-items: center;
  gap: 25px;
  padding: 25px;
}

.inputContainer__VK3jQ {
  width: 270px;
}

.startAdornment__uf49Q {
  color: var(--inputs-filled-text);
}

.rightSideContainer__p8xkV {
  margin-top: 25px;
}

.skeletonText__QSggX {
  height: 40px;
  width: 300px;
}

.actionsBlock__AADmh {
  display: flex;
  gap: 10px;
  height: 35px;
}

.separator__GWU1m {
  height: 35px;
  width: 1px;
  background: var(--tables-primary-row-stroke);
}`, "",{"version":3,"sources":["webpack://./../src/pages/MultiplicationFactors/components/CompanySavingCalculationSettings/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,yCAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,qDAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,YAAA;AAzEF;;AA4EA;EACE,gCAAA;AAzEF;;AA4EA;EACE,gBAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,SAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,UAAA;EACA,4CAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.companySavingTitle {\n  color: var(--title-inputs-sections-title);\n  font-style: normal;\n  line-height: 14px;\n  text-transform: uppercase;\n  font-weight: 400;\n  font-size: 11px;\n  margin: unset;\n  margin-bottom: 10px;\n}\n\n.companySavingBlockContainer {\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--basic-box-shadow);\n  display: flex;\n  align-items: center;\n  gap: 25px;\n  padding: 25px;\n}\n\n.inputContainer {\n  width: 270px;\n}\n\n.startAdornment {\n  color: var(--inputs-filled-text);\n}\n\n.rightSideContainer {\n  margin-top: 25px;\n}\n\n.skeletonText {\n  height: 40px;\n  width: 300px;\n}\n\n.actionsBlock {\n  display: flex;\n  gap: 10px;\n  height: 35px;\n}\n\n.separator {\n  height: 35px;\n  width: 1px;\n  background: var(--tables-primary-row-stroke);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"companySavingTitle": `companySavingTitle__ziGB_`,
	"companySavingBlockContainer": `companySavingBlockContainer__xfzmi`,
	"inputContainer": `inputContainer__VK3jQ`,
	"startAdornment": `startAdornment__uf49Q`,
	"rightSideContainer": `rightSideContainer__p8xkV`,
	"skeletonText": `skeletonText__QSggX`,
	"actionsBlock": `actionsBlock__AADmh`,
	"separator": `separator__GWU1m`
};
module.exports = ___CSS_LOADER_EXPORT___;
